export default __webpack_public_path__ + "fonts/SuisseIntlMono-Regular-WebXL.woff2";